<template>
  <!-- ADD TO TEXT FIELD: append-outer-icon="mdi-google-translate" -->
  <div class="box">
    <v-form ref="form">
      <v-row justify="center">
        <v-col align="center" cols="6">
          <v-text-field
            outlined
            dense
            label="Nombre"
            v-model="input.name"
            readonly
          ></v-text-field>
        </v-col>
        <v-col align="center" cols="6">
          <div class="d-flex">
            <div class="flag">
              <flag iso="es" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.es"
              @click:append-outer="translate(input.trans.name.es, 'es')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="it" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.it"
              @click:append-outer="translate(input.trans.name.it, 'it')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="gb" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.en"
              @click:append-outer="translate(input.trans.name.en, 'en')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="fr" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.fr"
              @click:append-outer="translate(input.trans.name.fr, 'fr')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="de" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.de"
              @click:append-outer="translate(input.trans.name.de, 'de')"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col align="center" cols="6">
          <v-text-field
            outlined
            dense
            label="Descripción"
            v-model="input.description"
            readonly
          ></v-text-field>
        </v-col>
        <v-col align="center" cols="6">
          <div class="d-flex">
            <div class="flag">
              <flag iso="es" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.description.es"
              @click:append-outer="translate(input.trans.description.es, 'es')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="it" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.description.it"
              @click:append-outer="translate(input.trans.description.it, 'it')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="gb" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.description.en"
              @click:append-outer="translate(input.trans.description.en, 'en')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="fr" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.description.fr"
              @click:append-outer="translate(input.trans.description.fr, 'fr')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="de" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.description.de"
              @click:append-outer="translate(input.trans.description.de, 'de')"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <template v-for="(ingredient, index) in input.ingredients">
        <v-row justify="center" v-if="input.ingredients.length" :key="index">
          <v-col align="center" cols="6">
            <v-text-field
              outlined
              dense
              label="Ingredientes/ Sabores"
              v-model="ingredient.item"
              readonly
            ></v-text-field>
          </v-col>
          <v-col align="center" cols="6">
            <div class="d-flex">
              <div class="flag">
                <flag iso="es" />
              </div>
              <v-text-field
                outlined
                dense
                v-model="ingredient.trans.es"
                @click:append-outer="translate(ingredient.trans.es, 'es')"
              ></v-text-field>
            </div>
            <div class="d-flex">
              <div class="flag">
                <flag iso="it" />
              </div>
              <v-text-field
                outlined
                dense
                v-model="ingredient.trans.it"
                @click:append-outer="translate(ingredient.trans.it, 'it')"
              ></v-text-field>
            </div>
            <div class="d-flex">
              <div class="flag">
                <flag iso="gb" />
              </div>
              <v-text-field
                outlined
                dense
                v-model="ingredient.trans.en"
                @click:append-outer="translate(ingredient.trans.en, 'en')"
              ></v-text-field>
            </div>
            <div class="d-flex">
              <div class="flag">
                <flag iso="fr" />
              </div>
              <v-text-field
                outlined
                dense
                v-model="ingredient.trans.fr"
                @click:append-outer="translate(ingredient.trans.fr, 'fr')"
              ></v-text-field>
            </div>
            <div class="d-flex">
              <div class="flag">
                <flag iso="de" />
              </div>
              <v-text-field
                outlined
                dense
                v-model="ingredient.trans.de"
                @click:append-outer="translate(ingredient.trans.de, 'de')"
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </template>
      <v-row justify="center">
        <v-col align="center">
          <v-btn @click.prevent="saveTranslations(input)" class="save-btn"
            >Guardar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "TranslateCartasPrincipales",
  props: ["data"],
  data() {
    return {
      input: {
        trans: {
          name: {
            es: this.data.trans ? this.data.trans.name.es : this.data.name,
            fr: this.data.trans ? this.data.trans.name.fr : this.data.name,
            en: this.data.trans ? this.data.trans.name.en : this.data.name,
            it: this.data.trans ? this.data.trans.name.it : this.data.name,
            de: this.data.trans ? this.data.trans.name.de : this.data.name
          },
          description: {
            es: this.data.trans
              ? this.data.trans.description.es
              : this.data.description,
            fr: this.data.trans
              ? this.data.trans.description.fr
              : this.data.description,
            en: this.data.trans
              ? this.data.trans.description.en
              : this.data.description,
            it: this.data.trans
              ? this.data.trans.description.it
              : this.data.description,
            de: this.data.trans
              ? this.data.trans.description.de
              : this.data.description
          }
        },
        ...this.data
      }
    };
  },
  methods: {
    saveTranslations(input) {
      this.$emit("saveToCollection", input);
    },
    translate(name, language) {
      console.log("SPANISH", name);
      console.log("language", language);
    }
  }
};
</script>
